import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store'
import FirebaseAuth from '@/services/firebase/auth'
import Swal from '@/plugins/sweetalert'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  routes
})

/** GUARD */
router.beforeEach(routerGuard)

async function routerGuard(to, from, next) {
  if(to.matched.some(record => record.meta.guest))
  {
    next()
  }
  else
  {
    if(!store.getters['auth/isLogged']) {
      try{
        await FirebaseAuth.onAuthStateChanged()
      }catch(error){
        console.error(error)
      }
    }

    if(store.getters['auth/isLogged'])
    {
      if(to.name == 'Login')
        next('/')
      else
        next()
    }
    else
    {
      if(to.name != 'Login')
        next('/login')
      else
        next()
    }
  }
}

export default router
